import gql from 'graphql-tag'

export default gql`
query AllConversations($userId: String!, $after: String, $first: Int) {
  allConversations(
    userId: $userId,
    after: $after,
    first: $first
  ) {
    items {
      id,
      userId,
      userType,
      user {
        id,
        name,
        avatarId,
        photoFlag,
        email
      },
      opponentId,
      opponentType,
      opponent {
        id,
        name,
        avatarId,
        photoFlag,
        email
      },
      lastMessageId,
      updatedAt,
      unreads,
      title,
      lastMessage {
        id,
        createdAt,
        ownerId,
        ownerType,
        opponentType,
        opponentId,
        conversationId,
        readedAt,
        content
      },
      internId
    },
    nextToken
  }
}`



// WEBPACK FOOTER //
// ./src/graphql/chat/queries/all-conversations.query.js